// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-4 -4 8 8\"><circle r=\"3\" fill=\"rgba%280, 0, 0, 0.25%29\"/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

/* map css start */
.accountSummary_setlite-location-card__cozpo {
    padding-top: 0px;
    padding-bottom: 40px;
  }
  
  .accountSummary_setlite-location-map__-p-I9 {
    padding-bottom: 40px;
  }
  
  .accountSummary_setlite-location-map__-p-I9 #accountSummary_map__CSbT7 {
    width: 100% !important;
    height:451px !important;
    border-radius: 0px;
  }
  
  .accountSummary_setlite-location-card__cozpo .accountSummary_price-sec__GgOZK .accountSummary_heading__-GMx8 {
    position: relative;
    color: #414141;
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    padding-left: 0;
  }
  
  .accountSummary_setlite-location-card__cozpo .accountSummary_price-sec__GgOZK span {
    color: #046A38;
    font-family: "Inter", sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
  }
  
  .accountSummary_setlite-location-card__cozpo .accountSummary_price-sec__GgOZK h3 {
    color: #046A38;
    font-family: "DM Sans", sans-serif;
    font-size: 40px;
    font-style: normal;
    font-weight: 500;
    line-height: 44px;
    margin-bottom: 0;
    text-align: left;
  }
  
  .accountSummary_setlite-location-card__cozpo .accountSummary_price-sec__GgOZK .accountSummary_trigger-btn__IfTLV {
    background: none;
    border: none;
  }
  
  #accountSummary_opentooltip__6I9Hc img {
    margin-bottom: 5px;
  }
  
  .accountSummary_setlite-location-card__cozpo .accountSummary_price-sec__GgOZK .accountSummary_address-info__4VDts {
    color: #666666;
    font-family: "Inter", sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    text-align: left;
  }
  
  .accountSummary_setlite-location-card__cozpo .accountSummary_read-info__qbvRG {
    color: #666666;
    font-family: "Inter", sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    padding-top: 24px;
  }
  
  .accountSummary_setlite-location-card__cozpo .accountSummary_plan-sec__4AdZC .accountSummary_plan-name__Bfj0j {
    color: #222222;
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }
  
  .accountSummary_setlite-location-card__cozpo .accountSummary_select-plan__GM6m3 .accountSummary_area-details__t4z7s {
    color: #666666;
    font-family: "Inter", sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 19.2px;
    margin-right: 14px;
  }
  
  .accountSummary_setlite-location-card__cozpo .accountSummary_bottom-border__Hk54G {
    margin: 11px 0;
    color: #00873C;
    opacity: 0.14;
    width: 100%;
  }
  
  .accountSummary_setlite-location-card__cozpo .accountSummary_plan-sec__4AdZC .accountSummary_select-plan__GM6m3 .accountSummary_form-switch__xvlMB .accountSummary_form-check-input__qTgCx {
    height: 24px;
    width: 39.484px;
    border-radius: 75px !important;
    min-height: 24px !important;
  }
  
  .accountSummary_setlite-location-card__cozpo .accountSummary_plan-sec__4AdZC .accountSummary_select-plan__GM6m3 .accountSummary_form-switch__xvlMB .accountSummary_form-check-input__qTgCx:focus {
    background-color: #ffffff;
    border-color: #00B140;
    border: 1px solid #e1e1e1;
    box-shadow: none;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }
  
  .accountSummary_setlite-location-card__cozpo .accountSummary_plan-sec__4AdZC .accountSummary_select-plan__GM6m3 .accountSummary_form-switch__xvlMB .accountSummary_form-check-input__qTgCx:checked {
    background-color: #00B140 !important;
    border-color: #00B140;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }
  
  /* tooltip css*/
  .accountSummary_info-popup__9K3KP {
    display: none;
    position: absolute;
    left: -21%;
    background-color: #ffffff;
    box-shadow: 0px 7px 7px 0px rgba(0, 0, 0, 0.09), 0px 2px 4px 0px rgba(0, 0, 0, 0.10), 0px 0px 8px 0px rgba(0, 0, 0, 0.10), 0px 0px 24px 0px rgba(0, 0, 0, 0.16);
    padding: 20px;
    z-index: 1;
    border-radius: 8px;
    width: 349px;
  }
  
  .accountSummary_info-popup__9K3KP::after {
    content: '';
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 6px;
    border-style: solid;
    border-color: transparent transparent #ffffff transparent;
  }
  
  .accountSummary_info-popup__9K3KP .accountSummary_info-box__LeMOq {
    display: flex;
    align-items: flex-start;
  }
  
  .accountSummary_info-popup__9K3KP .accountSummary_info-box__LeMOq .accountSummary_info-box-text__ikOd9 {
    color: #222222;
    font-family: "Inter", sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    margin-left: 29px;
  }
  
  .accountSummary_info-popup__9K3KP .accountSummary_info-box__LeMOq .accountSummary_info-box-text__ikOd9 img {
    position: absolute;
    left: 20px;
  }
  
  .accountSummary_info-popup__9K3KP .accountSummary_bf-close-btn__V1wlx {
    padding: 0;
    background-color: #ffffff;
    border: none;
    cursor: pointer;
    display: block
  }


@media screen and (max-width: 767px) {
    /* map css start */
  .accountSummary_setlite-location-card__cozpo {
    padding-top: 0px;
    padding-bottom: 24px;
  }

  .accountSummary_setlite-location-map__-p-I9 {
    padding-bottom: 16px;
  }

  .accountSummary_setlite-location-card__cozpo .accountSummary_setlite-location-map__-p-I9 img {
    height: 20px;
  }

  .accountSummary_setlite-location-card__cozpo .accountSummary_price-sec__GgOZK .accountSummary_heading__-GMx8 {
    font-size: 14px;
    line-height: 19.6px;
  }

  .accountSummary_setlite-location-card__cozpo .accountSummary_price-sec__GgOZK h3 {
    font-size: 32px;
    line-height: 36.8px;
  }

  .accountSummary_setlite-location-card__cozpo .accountSummary_price-sec__GgOZK {
    padding-bottom: 16px;
  }

  .accountSummary_setlite-location-card__cozpo .accountSummary_bottom-border__Hk54G {
    margin: 8px 0;
  }

  .accountSummary_info-popup__9K3KP {
    width: 300px;
    left: 0%;
  }

  .accountSummary_setlite-location-map__-p-I9 #accountSummary_map__CSbT7 {
    height: 201px !important;
  }
}

@media screen and (max-width: 600px) {
    .accountSummary_d-sm-map__giB0G {
        display: none;
    }

    .accountSummary_modal-content__toolbar-icons__X\\+Bay {
        display: flex;
        flex-direction: column;
        margin-top: 40px !important;
      }
    
      .accountSummary_setlite-location-map__-p-I9 .accountSummary_btn-panel__SfAwv .accountSummary_btn__continue__new__k9a-K {
        margin-top: 10px !important;
        display: block;
      }

      
}

@media only screen and (min-width: 1024px){
.accountSummary_modal--tutorial-prompt__i-RRX .accountSummary_modal-dialog__XzrDE{
  max-width: 800px !important;
}
}

.accountSummary_modal--tutorial-prompt__i-RRX .accountSummary_btn-close__c9X6r{
    position: absolute;
    right: 24px;
    top: 24px;
    width: 20px;
    height: 22px;
    display: flex;
    justify-content: center;
    cursor: pointer;
    background: none;
    opacity: 1;
    border: 0;
}
.accountSummary_modal--tutorial-prompt__i-RRX .accountSummary_btn-close__c9X6r:before,.accountSummary_modal--tutorial-prompt__i-RRX .accountSummary_btn-close__c9X6r:after {
    position: absolute;
    top: 0;
    content: ' ';
    height: 24px;
    width: 3px;
    background-color: #333;
    display: inline-block;
}
 .accountSummary_modal--tutorial-prompt__i-RRX .accountSummary_btn-close__c9X6r:before {
    transform: rotate(45deg);
}
.accountSummary_modal--tutorial-prompt__i-RRX .accountSummary_btn-close__c9X6r:after {
    transform: rotate(-45deg);
}
@media only screen and (min-width: 768px) and (max-width: 990px) {
  .accountSummary_modal--tutorial-prompt__i-RRX .accountSummary_modal-dialog__XzrDE{
    max-width: 600px !important;
}
}
@media screen and (max-width: 767px) {
  .accountSummary_modal--tutorial-prompt__i-RRX .accountSummary_modal-dialog__XzrDE{
    max-width: 100% !important;
}
}

.accountSummary_no-sqft__bYhFn{
  display: flex;
  justify-content: center;
}

.accountSummary_tru-mma-main-content-box__nw83K ,.accountSummary_tru-mma-main-service-box__r6OM2,.accountSummary_tru-mma-main-add__BlnoB,.accountSummary_tru-mma-main-wrapper__dpI6c {
    border:1px solid #6c757d !important;
}

@media screen and (max-width: 767px) {
    .accountSummary_tru-mma-main-content-box__nw83K {
        border: none !important;
    }
}

@media screen and (max-width: 767px) {
    .accountSummary_tru-mma-main-content__qA7q3 {
        background: #fff !important;
        border-bottom: 1px solid #9e9e9e;
    }
}

`, "",{"version":3,"sources":["webpack://./src/styles/myAccount/accountSummary.module.css"],"names":[],"mappings":";;AAEA,kBAAkB;AAClB;IACI,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,kCAAkC;IAClC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,cAAc;IACd,aAAa;IACb,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,8BAA8B;IAC9B,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,yBAAyB;IACzB,gBAAgB;IAChB,yDAA4J;EAC9J;;EAEA;IACE,oCAAoC;IACpC,qBAAqB;IACrB,yDAAuJ;EACzJ;;EAEA,eAAe;EACf;IACE,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,yBAAyB;IACzB,+JAA+J;IAC/J,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,iBAAiB;IACjB,mBAAmB;IACnB,yDAAyD;EAC3D;;EAEA;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf;EACF;;;AAGF;IACI,kBAAkB;EACpB;IACE,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,QAAQ;EACV;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,2BAA2B;MAC7B;;MAEA;QACE,2BAA2B;QAC3B,cAAc;MAChB;;;AAGN;;AAEA;AACA;EACE,2BAA2B;AAC7B;AACA;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,sBAAsB;IACtB,qBAAqB;AACzB;CACC;IACG,wBAAwB;AAC5B;AACA;IACI,yBAAyB;AAC7B;AACA;EACE;IACE,2BAA2B;AAC/B;AACA;AACA;EACE;IACE,0BAA0B;AAC9B;AACA;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,gCAAgC;IACpC;AACJ","sourcesContent":["\n\n/* map css start */\n.setlite-location-card {\n    padding-top: 0px;\n    padding-bottom: 40px;\n  }\n  \n  .setlite-location-map {\n    padding-bottom: 40px;\n  }\n  \n  .setlite-location-map #map {\n    width: 100% !important;\n    height:451px !important;\n    border-radius: 0px;\n  }\n  \n  .setlite-location-card .price-sec .heading {\n    position: relative;\n    color: #414141;\n    font-family: \"Inter\", sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n    padding-left: 0;\n  }\n  \n  .setlite-location-card .price-sec span {\n    color: #046A38;\n    font-family: \"Inter\", sans-serif;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 18px;\n  }\n  \n  .setlite-location-card .price-sec h3 {\n    color: #046A38;\n    font-family: \"DM Sans\", sans-serif;\n    font-size: 40px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 44px;\n    margin-bottom: 0;\n    text-align: left;\n  }\n  \n  .setlite-location-card .price-sec .trigger-btn {\n    background: none;\n    border: none;\n  }\n  \n  #opentooltip img {\n    margin-bottom: 5px;\n  }\n  \n  .setlite-location-card .price-sec .address-info {\n    color: #666666;\n    font-family: \"Inter\", sans-serif;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 18px;\n    text-align: left;\n  }\n  \n  .setlite-location-card .read-info {\n    color: #666666;\n    font-family: \"Inter\", sans-serif;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 18px;\n    padding-top: 24px;\n  }\n  \n  .setlite-location-card .plan-sec .plan-name {\n    color: #222222;\n    font-family: \"Inter\", sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n  }\n  \n  .setlite-location-card .select-plan .area-details {\n    color: #666666;\n    font-family: \"Inter\", sans-serif;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 19.2px;\n    margin-right: 14px;\n  }\n  \n  .setlite-location-card .bottom-border {\n    margin: 11px 0;\n    color: #00873C;\n    opacity: 0.14;\n    width: 100%;\n  }\n  \n  .setlite-location-card .plan-sec .select-plan .form-switch .form-check-input {\n    height: 24px;\n    width: 39.484px;\n    border-radius: 75px !important;\n    min-height: 24px !important;\n  }\n  \n  .setlite-location-card .plan-sec .select-plan .form-switch .form-check-input:focus {\n    background-color: #ffffff;\n    border-color: #00B140;\n    border: 1px solid #e1e1e1;\n    box-shadow: none;\n    background-image: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-4 -4 8 8\"><circle r=\"3\" fill=\"rgba%280, 0, 0, 0.25%29\"/></svg>');\n  }\n  \n  .setlite-location-card .plan-sec .select-plan .form-switch .form-check-input:checked {\n    background-color: #00B140 !important;\n    border-color: #00B140;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\");\n  }\n  \n  /* tooltip css*/\n  .info-popup {\n    display: none;\n    position: absolute;\n    left: -21%;\n    background-color: #ffffff;\n    box-shadow: 0px 7px 7px 0px rgba(0, 0, 0, 0.09), 0px 2px 4px 0px rgba(0, 0, 0, 0.10), 0px 0px 8px 0px rgba(0, 0, 0, 0.10), 0px 0px 24px 0px rgba(0, 0, 0, 0.16);\n    padding: 20px;\n    z-index: 1;\n    border-radius: 8px;\n    width: 349px;\n  }\n  \n  .info-popup::after {\n    content: '';\n    position: absolute;\n    bottom: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    border-width: 6px;\n    border-style: solid;\n    border-color: transparent transparent #ffffff transparent;\n  }\n  \n  .info-popup .info-box {\n    display: flex;\n    align-items: flex-start;\n  }\n  \n  .info-popup .info-box .info-box-text {\n    color: #222222;\n    font-family: \"Inter\", sans-serif;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 18px;\n    margin-left: 29px;\n  }\n  \n  .info-popup .info-box .info-box-text img {\n    position: absolute;\n    left: 20px;\n  }\n  \n  .info-popup .bf-close-btn {\n    padding: 0;\n    background-color: #ffffff;\n    border: none;\n    cursor: pointer;\n    display: block\n  }\n\n\n@media screen and (max-width: 767px) {\n    /* map css start */\n  .setlite-location-card {\n    padding-top: 0px;\n    padding-bottom: 24px;\n  }\n\n  .setlite-location-map {\n    padding-bottom: 16px;\n  }\n\n  .setlite-location-card .setlite-location-map img {\n    height: 20px;\n  }\n\n  .setlite-location-card .price-sec .heading {\n    font-size: 14px;\n    line-height: 19.6px;\n  }\n\n  .setlite-location-card .price-sec h3 {\n    font-size: 32px;\n    line-height: 36.8px;\n  }\n\n  .setlite-location-card .price-sec {\n    padding-bottom: 16px;\n  }\n\n  .setlite-location-card .bottom-border {\n    margin: 8px 0;\n  }\n\n  .info-popup {\n    width: 300px;\n    left: 0%;\n  }\n\n  .setlite-location-map #map {\n    height: 201px !important;\n  }\n}\n\n@media screen and (max-width: 600px) {\n    .d-sm-map {\n        display: none;\n    }\n\n    .modal-content__toolbar-icons {\n        display: flex;\n        flex-direction: column;\n        margin-top: 40px !important;\n      }\n    \n      .setlite-location-map .btn-panel .btn__continue__new {\n        margin-top: 10px !important;\n        display: block;\n      }\n\n      \n}\n\n@media only screen and (min-width: 1024px){\n.modal--tutorial-prompt .modal-dialog{\n  max-width: 800px !important;\n}\n}\n\n.modal--tutorial-prompt .btn-close{\n    position: absolute;\n    right: 24px;\n    top: 24px;\n    width: 20px;\n    height: 22px;\n    display: flex;\n    justify-content: center;\n    cursor: pointer;\n    background: none;\n    opacity: 1;\n    border: 0;\n}\n.modal--tutorial-prompt .btn-close:before,.modal--tutorial-prompt .btn-close:after {\n    position: absolute;\n    top: 0;\n    content: ' ';\n    height: 24px;\n    width: 3px;\n    background-color: #333;\n    display: inline-block;\n}\n .modal--tutorial-prompt .btn-close:before {\n    transform: rotate(45deg);\n}\n.modal--tutorial-prompt .btn-close:after {\n    transform: rotate(-45deg);\n}\n@media only screen and (min-width: 768px) and (max-width: 990px) {\n  .modal--tutorial-prompt .modal-dialog{\n    max-width: 600px !important;\n}\n}\n@media screen and (max-width: 767px) {\n  .modal--tutorial-prompt .modal-dialog{\n    max-width: 100% !important;\n}\n}\n\n.no-sqft{\n  display: flex;\n  justify-content: center;\n}\n\n.tru-mma-main-content-box ,.tru-mma-main-service-box,.tru-mma-main-add,.tru-mma-main-wrapper {\n    border:1px solid #6c757d !important;\n}\n\n@media screen and (max-width: 767px) {\n    .tru-mma-main-content-box {\n        border: none !important;\n    }\n}\n\n@media screen and (max-width: 767px) {\n    .tru-mma-main-content {\n        background: #fff !important;\n        border-bottom: 1px solid #9e9e9e;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"setlite-location-card": `accountSummary_setlite-location-card__cozpo`,
	"setlite-location-map": `accountSummary_setlite-location-map__-p-I9`,
	"map": `accountSummary_map__CSbT7`,
	"price-sec": `accountSummary_price-sec__GgOZK`,
	"heading": `accountSummary_heading__-GMx8`,
	"trigger-btn": `accountSummary_trigger-btn__IfTLV`,
	"opentooltip": `accountSummary_opentooltip__6I9Hc`,
	"address-info": `accountSummary_address-info__4VDts`,
	"read-info": `accountSummary_read-info__qbvRG`,
	"plan-sec": `accountSummary_plan-sec__4AdZC`,
	"plan-name": `accountSummary_plan-name__Bfj0j`,
	"select-plan": `accountSummary_select-plan__GM6m3`,
	"area-details": `accountSummary_area-details__t4z7s`,
	"bottom-border": `accountSummary_bottom-border__Hk54G`,
	"form-switch": `accountSummary_form-switch__xvlMB`,
	"form-check-input": `accountSummary_form-check-input__qTgCx`,
	"info-popup": `accountSummary_info-popup__9K3KP`,
	"info-box": `accountSummary_info-box__LeMOq`,
	"info-box-text": `accountSummary_info-box-text__ikOd9`,
	"bf-close-btn": `accountSummary_bf-close-btn__V1wlx`,
	"d-sm-map": `accountSummary_d-sm-map__giB0G`,
	"modal-content__toolbar-icons": `accountSummary_modal-content__toolbar-icons__X+Bay`,
	"btn-panel": `accountSummary_btn-panel__SfAwv`,
	"btn__continue__new": `accountSummary_btn__continue__new__k9a-K`,
	"modal--tutorial-prompt": `accountSummary_modal--tutorial-prompt__i-RRX`,
	"modal-dialog": `accountSummary_modal-dialog__XzrDE`,
	"btn-close": `accountSummary_btn-close__c9X6r`,
	"no-sqft": `accountSummary_no-sqft__bYhFn`,
	"tru-mma-main-content-box": `accountSummary_tru-mma-main-content-box__nw83K`,
	"tru-mma-main-service-box": `accountSummary_tru-mma-main-service-box__r6OM2`,
	"tru-mma-main-add": `accountSummary_tru-mma-main-add__BlnoB`,
	"tru-mma-main-wrapper": `accountSummary_tru-mma-main-wrapper__dpI6c`,
	"tru-mma-main-content": `accountSummary_tru-mma-main-content__qA7q3`
};
export default ___CSS_LOADER_EXPORT___;
